/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { toOrdinal } from '@common/util-foundation';
import { JourneyType } from '@common/util-models';
import {
  OrderSummary,
  SkyMobilePriceConfig,
  UI_BasketItem,
} from '@sky/util-models';

@Component({
  selector: 'sky-ui-order-summary',
  templateUrl: './order-summary.component.html',
  styleUrls: ['./order-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkyUiOrderSummaryComponent {
  private _orderSummary: OrderSummary | undefined;

  @Input()
  set orderSummary(value: OrderSummary | undefined) {
    this._orderSummary = value ? this.mapMobilePrices(value) : undefined;
  }

  get orderSummary(): OrderSummary | undefined {
    return this._orderSummary;
  }

  @Input() readOnly = false;
  @Input() journeyType!: JourneyType;

  @Output() edit: EventEmitter<string> = new EventEmitter();
  @Output() remove: EventEmitter<UI_BasketItem> = new EventEmitter();
  @Output() removeSkyBox: EventEmitter<void> = new EventEmitter();

  JourneyType = JourneyType;

  getAdditionalDevicesValue(orderSummary: OrderSummary): number {
    return orderSummary.totalAmount && orderSummary.skyBoxPrice
      ? orderSummary.totalAmount - orderSummary.skyBoxPrice
      : 0;
  }

  mapMobilePrices(vmOrderSummary: any) {
    if (vmOrderSummary.skyBoxName === 'Mobile phone cover') {
      const skyConfig = this.findSkyConfigByPrice(
        vmOrderSummary.purchasePrice,
        vmOrderSummary.skyMobilePriceConfig
      );

      const isCovered = vmOrderSummary.includedDevices[0]?.covered;
      const totalAmount = isCovered
        ? skyConfig.price + skyConfig.ltPrice
        : skyConfig.price;

      const includedDevices =
        vmOrderSummary.includedDevices?.map((device: any) => {
          if (isCovered) {
            return { ...device, coverPrice: skyConfig.ltPrice };
          }
          return device;
        }) || [];

      const updatedVmOrderSummary = {
        ...vmOrderSummary,
        skyBoxPrice: skyConfig.price,
        totalAmount: totalAmount,
        includedDevices: includedDevices,
      };

      return updatedVmOrderSummary;
    }

    return vmOrderSummary;
  }

  private findSkyConfigByPrice(
    inputValue: number,
    configs: SkyMobilePriceConfig[]
  ): SkyMobilePriceConfig {
    let lastConfig = configs[0] || ({} as SkyMobilePriceConfig);

    for (const config of configs) {
      lastConfig = config;
      if (config.purchasePrice >= inputValue) {
        return config;
      }
    }

    return lastConfig;
  }

  handleEdit(id: string) {
    this.edit.emit(id);
  }

  handleRemove(device: UI_BasketItem, isIncluded = false) {
    this.remove.emit({ ...device, isIncluded });
  }

  getFollowingMonth(numFreePayments: number): string {
    const startPaymentMonth = numFreePayments + 1;
    return toOrdinal(startPaymentMonth);
  }

  isSkyBox(device: UI_BasketItem): boolean {
    return device.category === 'Sky Box';
  }

  getSkyBoxName(skyBoxName?: string) {
    switch (skyBoxName) {
      case 'Devices only':
      case 'Device Only':
      case 'DevicesOnly':
      case 'Sky+ Glass Vip':
      case 'Q+_VIP':
      case 'VIRTUAL':
        return 'Sky Glass';

      case 'Sky Q Vip':
        return 'Sky Q';

      case 'Devics Only Vip':
        return 'Device Only';

      default:
        return skyBoxName;
    }
  }
}
